import FilterBox from "./filter-box";
import FilterBase from "./filter-base";
import { FilterActiveValue } from "./active-filters";

export default class RadioItemsFilter extends FilterBase {
    private inputs: HTMLInputElement[];

    private selectedInputClass = 'selected';
    private inputContainerSelector = '.radio-input';

    constructor(baseElement: HTMLElement, filterBox: FilterBox) {
        super(baseElement, filterBox);
    }

    public init(): void {
        this.inputs = [...this.baseElement.querySelectorAll('input')];
        this.inputs.forEach(input => this.setOnChangeAction(input));
    }

    private setOnChangeAction(input: HTMLInputElement): void {
        input.addEventListener('change', () => {
            this.updateSelectedValueFromInput();
            this.filterBox.refreshFiltersAndProducts();
        });
    }

    protected clearValuesInternal(): void {
        this.inputs.forEach(input => this.setInputChecked(input, false));
    }

    protected setValuesInternal(values: string): Promise<void> {
        this.setSelectedValue(values);

        return Promise.resolve();
    }

    public unselect(value: string): void {
        this.clear();
    }

    private updateSelectedValueFromInput(): void{
        const selectedValue = this.getSelectedValuesConcat();
        this.setSelectedValue(selectedValue);
        this.updateSelectedValuesAttribute();
    }

    protected getSelectedValuesConcat(): string{
        var input = this.getCheckedInput();
        if(input){
            return input.value;
        }
        return null;
    }

    private getCheckedInput(): HTMLInputElement{
        const selectedElements = this.inputs.filter(input => input.checked);
        if(selectedElements && selectedElements.length === 1){
            return selectedElements[0];
        }
        return null;
    }

    protected getActiveFilterValues(): FilterActiveValue[] {
        var input = this.getCheckedInput();
        if(input) {
            return [<FilterActiveValue> { value: input.value, displayName: input.name }];
        }
        return null;
    }

    private setSelectedValue(value: string): any{
        const input = this.inputs.find(i => i.value === value);
        if(input){
            this.setInputChecked(input, true);
        }
    }

    private setInputChecked(input: HTMLInputElement, checked: boolean): void {
        input.checked = checked;

        this.inputs.forEach(input => {
            (input.closest(this.inputContainerSelector) as HTMLElement).classList.remove(this.selectedInputClass)

        });
        if (checked) {
            (input.closest(this.inputContainerSelector) as HTMLElement).classList.add(this.selectedInputClass);
        }

    }
}

